import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { PropertiesService } from 'src/app/modules/properties/properties.service';
import { UsersService } from "src/app/modules/users/users.service";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';
var AssignTaggersDialogComponent = /** @class */ (function () {
    function AssignTaggersDialogComponent(dialogRef, data, configService, cookieService, translateService, propertiesService, authService, helperService, toastrService, usersService, apiService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.propertiesService = propertiesService;
        this.authService = authService;
        this.helperService = helperService;
        this.toastrService = toastrService;
        this.usersService = usersService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.add'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-save',
                inline: true,
            },
        };
        // END - form
        this.dialogIsLoading = true;
        this.initTaggers = [];
        dialogRef.disableClose = true;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    AssignTaggersDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser = res; }));
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        this.subscriptions.push(this.usersService.getTaggerList(0, 40, 'firstName').subscribe(function (res) {
            var e_1, _a;
            if (res.data.items && Array(res.data.items)) {
                try {
                    for (var _b = tslib_1.__values(res.data.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        _this.initTaggers.push({
                            _id: item._id,
                            completeName: item.completeName
                        });
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            // Init add form
            _this.initForm();
        }, function (err) {
            // Init add form
            _this.initForm();
        }));
        // Stop loading dialog
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    AssignTaggersDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    AssignTaggersDialogComponent.prototype.initForm = function () {
        // Set model
        this.model = {};
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: "col-12",
                        type: "autocomplete",
                        key: "tagger",
                        templateOptions: {
                            required: false,
                            customLabel: this.translateService.instant("properties.dialog.assignTagger.searchTagger"),
                            placeholder: this.translateService.instant("properties.dialog.assignTagger.searchTagger"),
                            initialValues: this.initTaggers,
                            bindLabel: "completeName",
                            bindValue: "_id",
                            search$: this.usersService.getTaggerList.bind(this),
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: 1 }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            loadingText: this.translateService.instant("common.words.loading"),
                        },
                    },
                ],
            },
        ];
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     * @param [data] optional data passed to the caller component
     */
    AssignTaggersDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    AssignTaggersDialogComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            return;
        }
        var userId = model.tagger;
        var data = {
            properties: []
        };
        if (this.data.properties && Array.isArray(this.data.properties)) {
            data.properties = this.data.properties;
        }
        this.subscriptions.push(this.propertiesService.assignTaggers(userId, data)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                _this.onClose({ updated: true });
                return;
            }
            // this.toastrService.error(this.translateService.instant('common.errors.unknown_server_error'));
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    return AssignTaggersDialogComponent;
}());
export { AssignTaggersDialogComponent };
